import { Helmet } from 'react-helmet-async';
import { CircularProgress, Container, Grid } from '@mui/material';
import Footer from 'src/components/Footer';
import { Chart } from 'react-google-charts';
export const data = [
  ['City', '2010 Population', '2000 Population'],
  ['New York City, NY', 8175000, 8008000],
  ['Los Angeles, CA', 3792000, 3694000],
  ['Chicago, IL', 2695000, 2896000],
  ['Houston, TX', 2099000, 1953000],
  ['Philadelphia, PA', 1526000, 1517000]
];

export const options = {
  title: 'Population of Largest U.S. Cities',
  chartArea: { width: '50%' },
  hAxis: {
    title: 'Total Population',
    minValue: 0
  },
  vAxis: {
    title: 'City'
  }
};

function Charts() {
  return (
    <>
      <Helmet>
        <title>PGE Charts</title>
      </Helmet>

      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={1}
        >
          <Grid item lg={12} xs={12}>
            <Chart
              chartType="ScatterChart"
              data={[
                ['Age', 'Weight'],
                [4, 5.5],
                [8, 12]
              ]}
              width="100%"
              height="400px"
              legendToggle
            />
          </Grid>

          <Grid item xs={12}>
            <Chart
              chartType="BarChart"
              width="100%"
              height="400px"
              data={data}
              options={options}
            />
          </Grid>
          <Grid item xs={12}></Grid>
        </Grid>
      </Container>
      <Footer />
    </>
  );
}

export default Charts;
